import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ResetSection() {
  const tableData = [{
    sit: 'Niebla mental que mejoró pero vuelve los días estresantes',
    sin: 'Sin sellado intestinal',
    con: 'Protocolo de Soldadura Intestinal + L-glutamina'
  }, {
    sit: 'Permeabilidad intestinal que no termina de cerrar',
    sin: 'Sin estrategia específica de sellado',
    con: 'Zinc-carnosina + colágeno + mucílagos vegetales'
  }, {
    sit: 'Reactividad a comidas que antes tolerabas',
    sin: 'Sin reparación de mucosa',
    con: 'Reintroducción guiada + reparación celular profunda'
  }, {
    sit: 'Energía que cae en picada por la tarde',
    sin: 'Sin soporte mitocondrial',
    con: 'Stack mitocondrial + CoQ10 + magnesio'
  }, {
    sit: 'Inflamación silenciosa de bajo grado',
    sin: 'Sin protocolo antiinflamatorio sostenido',
    con: 'Cúrcuma + omega-3 + polifenoles funcionales'
  }, {
    sit: 'Recuperación de la velocidad mental anterior',
    sin: 'Sin neuroprotección',
    con: 'Plan neuroactivo + grasas cerebrales esenciales'
  }];
  const includes = ['Diagnóstico de Permeabilidad', 'Protocolo de Soldadura Intestinal', 'Stack de Reparación Celular', 'Reintroducción Guiada', 'Soporte Mitocondrial', 'Antiinflamatorio Sostenido', 'Plan Maestro 60 Días Post-Niebla'];
  return <section className="py-24 bg-brand-black border-t border-brand-gold/20" data-id="element-253">
      <div className="container mx-auto px-4" data-id="element-254">
        <div className="max-w-5xl mx-auto" data-id="element-255">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-256">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-gold mb-4 font-[Poppins,_sans-serif]" data-id="element-257">
              🌱 ¿QUÉ AGREGA EL ACELERADOR DE REPARACIÓN CELULAR 2.0™?
            </h2>
            <p className="text-gray-300 max-w-2xl mx-auto" data-id="element-258">
              El Protocolo de Soldadura Intestinal que acelera la recuperación y
              sella la permeabilidad de forma permanente.
            </p>
          </motion.div>

          {/* Desktop table */}
          <div className="hidden md:block overflow-x-auto mb-16 rounded-xl border border-gray-800" data-id="element-259">
            <table className="w-full text-left border-collapse" data-id="element-260">
              <thead data-id="element-261">
                <tr className="bg-brand-dark" data-id="element-262">
                  <th className="p-4 border-b border-gray-800 font-bold text-white w-1/3" data-id="element-263">
                    Situación
                  </th>
                  <th className="p-4 border-b border-gray-800 font-bold text-red-400 w-1/3" data-id="element-264">
                    <div className="flex items-center gap-2" data-id="element-265">
                      <X className="w-4 h-4" data-id="element-266" /> Sin Acelerador
                    </div>
                  </th>
                  <th className="p-4 border-b border-gray-800 font-bold text-brand-light w-1/3" data-id="element-267">
                    <div className="flex items-center gap-2" data-id="element-268">
                      <Check className="w-4 h-4" data-id="element-269" /> Con Acelerador
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-800" data-id="element-270">
                {tableData.map((row, i) => <tr key={i} className="hover:bg-brand-dark/50 transition-colors" data-id="element-271">
                    <td className="p-4 text-gray-300" data-id="element-272">{row.sit}</td>
                    <td className="p-4 text-gray-500" data-id="element-273">{row.sin}</td>
                    <td className="p-4 text-brand-light font-medium" data-id="element-274">
                      {row.con}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile stacked cards */}
          <div className="md:hidden mb-16 rounded-2xl border border-gray-800 overflow-hidden" data-id="element-275">
            {/* Header */}
            <div className="bg-brand-dark p-5 flex flex-col items-center gap-3" data-id="element-276">
              <div className="flex items-center gap-2 text-red-400 font-bold text-base" data-id="element-277">
                ❌ Sin Acelerador
              </div>
              <div className="flex items-center gap-2 text-brand-light font-bold text-base" data-id="element-278">
                ✅ Con Acelerador
              </div>
            </div>

            {/* Rows */}
            {tableData.map((row, i) => <div key={i} className="border-t border-gray-800" data-id="element-279">
                {/* Situación */}
                <div className="px-5 py-4 bg-brand-black" data-id="element-280">
                  <p className="text-xs font-bold text-gray-400 mb-1" data-id="element-281">
                    Situación:
                  </p>
                  <p className="text-sm text-gray-200" data-id="element-282">{row.sit}</p>
                </div>
                {/* Sin */}
                <div className="px-5 py-4 bg-brand-dark/80" data-id="element-283">
                  <p className="text-xs font-bold text-red-400 mb-1 flex items-center gap-1.5" data-id="element-284">
                    ❌ Sin Acelerador:
                  </p>
                  <p className="text-sm text-gray-400" data-id="element-285">{row.sin}</p>
                </div>
                {/* Con */}
                <div className="px-5 py-4 bg-brand-green/5" data-id="element-286">
                  <p className="text-xs font-bold text-brand-light mb-1 flex items-center gap-1.5" data-id="element-287">
                    ✅ Con Acelerador:
                  </p>
                  <p className="text-sm text-gray-200" data-id="element-288">{row.con}</p>
                </div>
              </div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-gold/5 border border-brand-gold/20 rounded-2xl p-8 md:p-10" data-id="element-289">
            <h3 className="text-xl font-bold text-brand-gold mb-6 text-center" data-id="element-290">
              ✅ EL ACELERADOR INCLUYE:
            </h3>
            <div className="flex flex-wrap justify-center gap-3" data-id="element-291">
              {includes.map((item, index) => <span key={index} className="bg-brand-dark border border-brand-gold/30 text-gray-200 px-4 py-2 rounded-full text-sm" data-id="element-292">
                  {item}
                </span>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}